"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _keymirror = _interopRequireDefault(require("keymirror"));

var _AsyncRequest = _interopRequireDefault(require("../AsyncRequest"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var _default = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, (0, _keymirror.default)({
  SET_IS_AUTHENTICATED: null,
  CHANGE_AUTH_PAGE: null
})), _AsyncRequest.default.createActionKeys('LOGIN')), _AsyncRequest.default.createActionKeys('LOGOUT')), _AsyncRequest.default.createActionKeys('REQUEST_PASSWORD_RESET')), _AsyncRequest.default.createActionKeys('RESET_PASSWORD')), _AsyncRequest.default.createActionKeys('REDIRECT')), _AsyncRequest.default.createActionKeys('RESET_PASSWORD_AND_LOGIN')), _AsyncRequest.default.createActionKeys('GET_PASSWORD_RESET_INFO')), _AsyncRequest.default.createActionKeys('SEND_MAGIC_LINK')), _AsyncRequest.default.createActionKeys('VALIDATE_MAGIC_LINK'));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/auth/authActionKeys.js
// module id = 938
// module chunks = 25